import { AbilityBuilder } from '@casl/ability';
import { AppAbility, Role } from './define-permissions';

export const tenantContextPermissions = (
  builder: AbilityBuilder<AppAbility>,
  role: Role,
  userToken: string,
  isSSO: boolean,
) => {
  const { can } = builder;

  can('read', 'OrganizationDetails');

  can('read', 'TenantAdministrators');

  can('read', 'TenantEmployees');

  can('read', 'TenantEmployeesJoinRequest');

  can('read', 'TenantEmployeesAccess');

  can('read', 'TenantEmployeesDisplayedApplications');

  can('read', 'TenantApplications');

  can('read', 'TenantDomains');

  can('read', 'TenantEmployeeJoinMethod');

  can('read', 'Password');
  if (!isSSO) {
    can('update', 'Password');
  }

  can('read', 'TenantContactForm');
  can('create', 'TenantContactForm');

  can('read', 'TenantEvents');

  can('read', 'TenantPolls');

  can('read', 'TenantPosts');

  can('read', 'TenantSiteDetails');

  can('read', 'TenantReceptionDetails');

  can('read', 'TenantMessages');

  can('read', 'TenantAuditLogs');

  if (role === 'admin' || role === 'owner' || role === 'master') {
    if (!isSSO) {
      can('create', 'TenantEmployees');
      can('upload', 'TenantEmployees');
      can('update', 'TenantEmployees');
      can('delete', 'TenantEmployees');
      can('resendInvitation', 'TenantEmployees');

      can('grant', 'TenantEmployeesAccess');
      can('update', 'TenantEmployeesAccess');
      can('revoke', 'TenantEmployeesAccess');

      can('stopDisplaying', 'TenantEmployeesDisplayedApplications');

      can('approve', 'TenantEmployeesJoinRequest');
      can('reject', 'TenantEmployeesJoinRequest');

      can('create', 'TenantDomains');
      can('delete', 'TenantDomains');

      can('setAsDefault', 'TenantApplications');
      can('removeFromDefault', 'TenantApplications');

      can('update', 'TenantEmployeeJoinMethod');
    }

    can('create', 'TenantEvents');
    can('update', 'TenantEvents');
    can('delete', 'TenantEvents');

    can('create', 'TenantPolls');
    can('update', 'TenantPolls');
    can('delete', 'TenantPolls');

    can('create', 'TenantPosts');
    can('update', 'TenantPosts');
    can('delete', 'TenantPosts');
    can('publish', 'TenantPosts');
    can('unpublish', 'TenantPosts');

    can('create', 'TenantReceptionDetails');
    can('update', 'TenantReceptionDetails');
    can('delete', 'TenantReceptionDetails');

    can('create', 'TenantMessages');
    can('update', 'TenantMessages');
    can('delete', 'TenantMessages');
    can('publish', 'TenantMessages');
    can('duplicate', 'TenantMessages');
  }

  if (role === 'owner' || role === 'master') {
    can('updatePhoneNumber', 'TenantAdministrators');
    can('updateRole', 'TenantAdministrators', {
      userToken: { $ne: userToken },
    });

    if (!isSSO) {
      can('create', 'TenantAdministrators');

      can('delete', 'TenantAdministrators', {
        userToken: { $ne: userToken },
      });
      can('resendInvitation', 'TenantAdministrators', {
        userToken: { $ne: userToken },
      });
    }
  }

  if (role === 'admin') {
    can('updatePhoneNumber', 'TenantAdministrators', {
      role: { $ne: 'OWNER' },
    });
    can('updateRole', 'TenantAdministrators', {
      userToken: { $ne: userToken },
      role: { $nin: ['OWNER', 'ADMIN'] },
      selectedRole: { $nin: ['OWNER', 'ADMIN'] },
    });

    if (!isSSO) {
      can('create', 'TenantAdministrators', {
        userToken: { $ne: userToken },
        role: { $nin: ['OWNER', 'ADMIN'] },
        selectedRole: { $nin: ['OWNER', 'ADMIN'] },
      });
      can('delete', 'TenantAdministrators', {
        userToken: { $ne: userToken },
        role: { $nin: ['OWNER', 'ADMIN'] },
        selectedRole: { $nin: ['OWNER', 'ADMIN'] },
      });
      can('resendInvitation', 'TenantAdministrators', {
        userToken: { $ne: userToken },
        role: { $nin: ['OWNER', 'ADMIN'] },
      });
    }
  }
};
